(ns teamoesterreich.admin-mode.text-blocks.create-with-name-and-type-modal
  (:require [teamoesterreich.util.helper :as h]             ;;(h/event-value e)
            [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.done :refer [done]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            ))


(defn modal [!show on-ok-fn & [on-cancel-fn]]
  (let [!new-name (r/atom "")
        !new-type (r/atom "md")
        ]
    (fn []
      [mui/modal
       {
        :aria-labelledby  "simple-modal-title"
        :aria-describedby "simple-modal-description"
        :style            {:display        "flex"
                           :marginRight    "auto"
                           :marginLeft     "auto"
                           :alignItems     "center"
                           :justifyContent "center"}
        :open             (or @!show false)

        }
       [mui/paper
        {
         :class "modal"
         :style {:min-width "600px"}}
        [:h4 "Neue Vorlage erstellen "]

        [mui/grid
         {:container  true
          :direction  "row"
          :justify    "flex-start"
          :alignItems "stretch"
          :spacing    2
          }
         [mui/grid
          {:container false
           :item      true
           :xs        12                                    ;extra-small: 0px
           }
          [mui/form-control
           {:fullWidth false
            :style     {:min-width "250px"}}
           [mui/input-label "Vorlagen Art"]
           [mui/select
            {:value    @!new-type
             :onChange (fn [e] (reset! !new-type (h/event-value e)))
             :label    "Vorlagen Art"}
            [mui/menu-item {:value "email"} "Email"]
            [mui/menu-item {:value "sms"} "Sms"]
            [mui/menu-item {:value "md"} "Formatierter Text"]
            ;[mui/menu-item {:value "line"} "Textzeile"]
            ;[mui/menu-item {:value "block"} "Textblock"]
            ]]
          ]
         [mui/grid
          {:container false
           :item      true
           :xs        12                                    ;extra-small: 0px
           }
          [mui/text-field
           {:onChange  (fn [e] (reset! !new-name (h/event-value e)))
            :label     "Name"
            :fullWidth true
            }]
          ]]
        [:br]
        [:br]
        [mui/button
         {:color     "primary"
          :variant   "contained"
          :startIcon (r/as-element [keyboard-arrow-left])
          :style     {:marginRight 50}
          :onClick   (fn []
                       (if on-cancel-fn
                         (on-cancel-fn)
                         (reset! !show false)))
          }
         "Abbrechen"]
        [mui/button
         {:style     {:float "right"}
          :variant   "contained"
          :disabled  (if (= @!new-name "") true false)
          :startIcon (r/as-element [done])
          :onClick   (fn []
                       (on-ok-fn @!new-name @!new-type)
                       (reset! !show false))
          }
         "Erstellen"]]
       ])
    ))


